import script from "./department-list.vue?vue&type=script&setup=true&lang=js"
export * from "./department-list.vue?vue&type=script&setup=true&lang=js"

import "./department-list.vue?vue&type=style&index=0&id=25b18006&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25b18006"]])

export default __exports__